import React, { useState } from 'react'
import FlatPage from '@components/Misc/FlatPage'
import { DOWNLOAD_FLATPAGE_URL, PAYMENT_FLATPAGE_URL, RETURN_FLATPAGE_URL, SHIPPING_FLATPAGE_URL } from '../../../urls'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import PaymentIcon from '@icons/PaymentIcon'
import ShippingIcon from '@icons/ShippingIcon'
import ReturnIcon from '@icons/ReturnIcon'
import ResponsiveDialog from '@components/ResponsiveDialog'

interface IProps {
  isDigital: boolean
}

const ProductInfoLinks: React.FC<IProps> = ({ isDigital }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [title, setTitle] = useState('')

  const [flatPageUrl, setFlatPageUrl] = useState(null)
  const handleClickOpen = (url: string) => {
    setFlatPageUrl(url)
    setOpen(true)
  }

  return (
    <>
      <div className='flex gap-2 justify-center my-10'>
        <Button
          startIcon={<ShippingIcon viewBox='0 0 20 20' />}
          onClick={() => handleClickOpen(SHIPPING_FLATPAGE_URL)}
          sx={{
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
          disableRipple
        >
          <span className='uppercase font-normal text-gray text-11'>{t('shipping', 'Shipping')}</span>
        </Button>

        <Button
          startIcon={<PaymentIcon viewBox='0 0 20 20' />}
          onClick={() => handleClickOpen(PAYMENT_FLATPAGE_URL)}
          sx={{
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
          disableRipple
        >
          <span className='uppercase font-normal text-gray text-11'>{t('payment', 'Payment')}</span>
        </Button>
        <Button
          startIcon={<ReturnIcon viewBox='0 0 20 20' />}
          onClick={() => handleClickOpen(RETURN_FLATPAGE_URL)}
          sx={{
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
          disableRipple
        >
          <span className='uppercase font-normal text-gray text-11'>{t('return', 'Return')}</span>
        </Button>
        {isDigital && (
          <Button
            startIcon={<PaymentIcon viewBox='0 0 20 20' />}
            onClick={() => handleClickOpen(DOWNLOAD_FLATPAGE_URL)}
            sx={{
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
            disableRipple
          >
            <span className='uppercase font-normal text-gray text-11'>{t('button.download', 'Download')}</span>
          </Button>
        )}
      </div>
      <ResponsiveDialog title={title} isOpenDialog={open} setIsOpenDialog={setOpen}>
        {flatPageUrl && <FlatPage url={flatPageUrl} variant='dialog' changePageTitle={setTitle} />}
      </ResponsiveDialog>
    </>
  )
}

export default ProductInfoLinks
